import React, { FC } from "react";
import { Redirect } from "react-router-dom";

export const LoginCallback: FC = () => <Redirect to="/" />;
